import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_DEPARTMENTS_REQUEST, fetchDepartmentsSuccess, fetchDepartmentsFailure,
  CREATE_DEPARTMENT_REQUEST, createDepartmentSuccess, createDepartmentFailure,
  UPDATE_DEPARTMENT_REQUEST, updateDepartmentSuccess, updateDepartmentFailure,
  DELETE_DEPARTMENT_REQUEST, deleteDepartmentSuccess, deleteDepartmentFailure
} from '../actions/departmentActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');
function* fetchDepartments(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching dep with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/department`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchDepartmentsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching batches: ", error);
    yield put(fetchDepartmentsFailure(error.response?.data?.message || error.message));
  }
}

function* createDepartment(action) {
  try {
    const projectId= action.payload.projectId
    delete action.payload.projectId;
    const response = yield call(axios.post, `${API_BASE_URL}/${projectId}/department`, action.payload,{
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    yield put(createDepartmentSuccess(response.data));
  } catch (error) {
    yield put(createDepartmentFailure(error.message));
  }
}

function* updateDepartment(action) {
  try {
    const { id, data, projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/department/${id}`, data,{
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    yield put(updateDepartmentSuccess(response.data));
  } catch (error) {
    yield put(updateDepartmentFailure(error.message));
  }
}

function* deleteDepartment(action) {
  try {
    const { id, projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/department/${id}`,{
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    yield put(deleteDepartmentSuccess(id));
  } catch (error) {
    yield put(deleteDepartmentFailure(error.message));
  }
}

export default function* departmentSaga() {
  yield takeLatest(FETCH_DEPARTMENTS_REQUEST, fetchDepartments);
  yield takeLatest(CREATE_DEPARTMENT_REQUEST, createDepartment);
  yield takeLatest(UPDATE_DEPARTMENT_REQUEST, updateDepartment);
  yield takeLatest(DELETE_DEPARTMENT_REQUEST, deleteDepartment);
}
